import { Paths } from '../types/Paths';

export default function getPropertyOf<T>(data: T, keys: Paths<T>): unknown {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (keys as string[]).reduce<any>((current, key) => current?.[key], data);
}
